// extracted by mini-css-extract-plugin
module.exports = {"headerLogoAdv":"GNaa9","border":"GNaa-","link":"GNch","advMarker":"GNlx","advMarkerText":"GNabb","clickArea":"GNabd","informer":"GNaa3"};